import { connect } from "react-redux";
import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { checkCart } from "../../redux/cart/action";
import CartItem from "./CartItem";
import { isMobileSafari, isSafari } from "react-device-detect";
import { getLocalStore } from "../../helper/utility";

const CompleteOrder = (props) => {
  const [modalOpen, setModalOpen] = useState(false);

  const toggle = () => setModalOpen((prev) => !prev);

  const items = props.cartReducer.cart
    .filter((el) => el.updated === true)
    .map((el) => (
      <CartItem
        key={el.skul}
        showOldPrice={true}
        showQuantity={false}
        item={el}
      />
    ));

  const completeOrder = () => {
    const localStore = getLocalStore();
    let link = `https://www.giodicart.it/vi/${localStore}`;
    toggle();

    if (isSafari) {
      setTimeout(() => {
        window.open(link, "_blank");
      });
    } else {
      const openTo = isMobileSafari ? "_self" : "_blank";
      window.open(`${link}`, openTo);
    }
  };

  return (
    <>
      <Button
        className="buttonActionCart"
        color="success"
        onClick={() => {
          props.checkCart((res) => {
            if (res) {
              setModalOpen(true);
              return;
            }
            completeOrder();
          });
        }}
      >
        <i className="fas fa-store">
          <span> Completa</span>
        </i>
      </Button>
      <Modal centered isOpen={modalOpen && items.length > 0} toggle={toggle}>
        <ModalHeader toggle={toggle}>Attenzione</ModalHeader>
        <ModalBody className="d-flex justify-content-around">{items}</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={completeOrder}>
            Prosegui
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cartReducer: state.cartReducer,
  };
};

export default connect(mapStateToProps, { checkCart })(CompleteOrder);
